import chroma from 'chroma-js';

export const generateRandomColor = () => chroma.random().hex();
